import { SxProps, TooltipProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';

export interface Tooltip {
  children: ReactElement<any, any> & ReactNode;
  disableFocusListener?: boolean;
  disableHoverListener?: boolean;
  disableTouchListener?: boolean;
  title: string | ReactNode;
  placement?: TooltipProps['placement'];
  onClick?: (event?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClose?: () => void;
  open?: boolean;
  PopperProps?: any;
  sx?: SxProps;
  arrow?: boolean;
}

export const Tooltip: React.FC<Tooltip> = ({
  children,
  disableFocusListener = false,
  disableHoverListener = false,
  disableTouchListener = false,
  onClick,
  onClose,
  open,
  placement,
  PopperProps,
  title,
  sx,
  arrow = false,
}) => {
  return (
    <MuiTooltip
      title={title}
      arrow={arrow}
      placement={placement}
      onClick={onClick}
      PopperProps={PopperProps}
      onClose={onClose}
      open={open}
      disableFocusListener={disableFocusListener}
      disableHoverListener={disableHoverListener}
      disableTouchListener={disableTouchListener}
      sx={sx}
    >
      {children}
    </MuiTooltip>
  );
};
